import { render, staticRenderFns } from "./PersonasTabMantCalenlab.vue?vue&type=template&id=e0f90072"
import script from "./PersonasTabMantCalenlab.vue?vue&type=script&lang=js"
export * from "./PersonasTabMantCalenlab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports